const manageGroundStation = {
  manageGroundStation: {
    pageTitle: 'Manage Ground Station',
    description: 'Check and access the registered ground stations',
    searchPlaceholder: 'Search',
    addButton: 'Add',
    viewDetailsButton: 'View Details'
  }
};

export default manageGroundStation;